import { AxiosInstance } from 'axios';
import {
  ContactToScheduleApplyPreconditionRepository,
  ContactToScheduleApplyPreconditionRequest,
  ContactToScheduleApplyPreconditionResponse,
} from '@/model/repository/manager/parentContacts/ContactToScheduleApplyPreconditionRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ContactToScheduleApplyPreconditionRepository => ({
    get(query: ContactToScheduleApplyPreconditionRequest) {
      return Repository.get<ContactToScheduleApplyPreconditionResponse>(resource, { params: query });
    },
  });
